export default "__VITE_ASSET__08d4f881__"